import * as React from 'react';
import { SVGProps } from 'react';

const IconPriceLabelStrokedSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M16.049 5.967a1.984 1.984 0 1 1 0 3.967 1.984 1.984 0 0 1 0-3.967Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 2a2 2 0 0 1 2 1.999v7.09c0 .53-.21 1.039-.586 1.414l-8.91 8.908-.152.137a2 2 0 0 1-2.525 0l-.152-.137-7.09-7.089-.138-.151a2 2 0 0 1 .138-2.677l8.91-8.908c.329-.328.76-.53 1.217-.576L12.91 2H20Zm-7.09 2L4 12.908l7.09 7.088L20 11.09v-7.09L12.91 4Z"
    />
  </svg>
);
export default IconPriceLabelStrokedSizeM;
